import { render, staticRenderFns } from "./showVideo.vue?vue&type=template&id=fd67e294&scoped=true"
import script from "./showVideo.vue?vue&type=script&lang=js"
export * from "./showVideo.vue?vue&type=script&lang=js"
import style0 from "./showVideo.vue?vue&type=style&index=0&id=fd67e294&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd67e294",
  null
  
)

export default component.exports